/**
 * @file Landing Faq
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Landing Faq component
 */
const vLandingFaq = () => {
	const landingFaq = document.querySelector( '.v-landing-faq' ) || document.querySelector( '.v-accordions-list' );

	if ( ! landingFaq ) {
		return;
	}

	gsap.registerPlugin( ScrollToPlugin );

	const buttons       = document.querySelectorAll( '.v-landing-faq__button' );
	const learnMoreBtns = landingFaq.querySelectorAll( '.v-landing-faq__section-cta' );
	const dataLayer     = window.dataLayer || [];

	[ ...buttons ].forEach( ( button ) => {
		button.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			const target = event.target;
			const hash   = target.getAttribute( 'href' );

			if ( ! hash ) {
				return;
			}

			const name    = target.getAttribute( 'data-name' );
			const section = document.querySelector( hash );

			dataLayer.push( {
				event:          'Segment Landing FAQ',
				vEventCategory: 'Consumer',
				vEventAction:   'Click',
				vEventLabel:    name,
			} );

			gsap.to(
				window,
				{
					duration: 1,
					ease:     'power2.inOut',
					scrollTo: {
						y:        section.offsetTop,
						autoKill: false,
					},
				} );
		} );
	} );

	[ ...learnMoreBtns ].forEach( ( btn ) => {
		btn.addEventListener( 'click', () => {
			dataLayer.push( {
				event:          'Segment Landing Learn More',
				vEventCategory: 'Consumer',
				vEventAction:   'Click',
				vEventLabel:    'Learn More',
			} );
		} );
	} );
};

export default vLandingFaq;
